module.exports = __webpack_public_path__ + "img/banner.778d34d8.png";